import React from "react";

export const DEFAULT_DURATION_CHIPS = [10, 15, 30, 45, 60, 90, 120];

/**
 * Quick-select minute chips under the duration field. Extracted from
 * TrainingLogForm so the Performance flow renders the identical control.
 */
const DurationQuickChips: React.FC<{
  onSelect: (minutes: number) => void;
  options?: number[];
}> = ({ onSelect, options = DEFAULT_DURATION_CHIPS }) => (
  <div className="flex flex-wrap gap-1.5 mt-2">
    {options.map((mins) => (
      <button
        key={mins}
        type="button"
        onClick={() => onSelect(mins)}
        className="px-3 py-1.5 rounded-full text-sm font-geist tabular-nums border bg-base-100 text-base-content/70 border-base-300 hover:border-base-content/40 transition-colors"
      >
        {mins}
      </button>
    ))}
  </div>
);

export default DurationQuickChips;
